import React from 'react';
import Select, { ActionMeta } from 'react-select';
import classNames from 'classnames';
import { componentSizeVariantsEnum } from 'src/constants';
import Label from '../label/Label';
import cx from './suggestionSelectField.module.scss';
import { Autocomplete, TextField } from '@mui/material';
import ErrorMessage from '../errorMessage/ErrorMessage';
import RenderItem from './renderItem';

interface optionItem { label: string, value: string }
interface TSuggestionSelectFieldProps {
    label?: string,
    options: optionItem[],
    placeholder?: string,
    isSearchable?: boolean,
    variant?: componentSizeVariantsEnum;
    required?: boolean,
    inputId?: string,
    onChange?: (newValue: any, actionMeta?: ActionMeta<any>, e?: React.SyntheticEvent<Element, Event>) => void,
    value?: string,
    errorMessage?: string,
    isTouched?: boolean
}
export default function SuggestionSelectField({ options, label, onChange, value, placeholder = '', variant = componentSizeVariantsEnum.MEDIUM, required = false, inputId = '', errorMessage = '', isTouched = false }: TSuggestionSelectFieldProps) {
    const valueObj = options.find((item) => item.label === value) || null;

    return (
        <div className={classNames(
            'input-field-component',
            `input-field-component--${variant}`
        )}>
            {label && (
                <Label htmlFor={inputId} variant={variant} required={required}>
                    {label}
                </Label>
            )}
            <div className={cx.selectBox}>
                <Autocomplete
                    disablePortal
                    options={options}
                    getOptionLabel={(option: { label: string, value: string, logo?: string }) => option.label}
                    isOptionEqualToValue={(option: { label: string, value: string, logo?: string }, value: { label: string, value: string, logo?: string }) => option?.value === value?.value}
                    value={valueObj}
                    onChange={(e, newValue) => onChange?.(newValue, undefined, e)}
                    onInputChange={(e: React.SyntheticEvent<Element, Event>, newInputValue: string, reason: string) => {
                        if (reason === "input") {
                            onChange?.({ label: newInputValue, value: newInputValue }, undefined, e);
                        }
                    }}
                    componentsProps={{
                        popupIndicator: {
                          sx: { display: 'none' }
                        }
                      }}
                    renderOption={(props, option: { label: string, value: string, logo?: string }) => (
                        <RenderItem option={option} props={props} key={option.value} />
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder={placeholder}
                            autoComplete="off"
                            inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password" // Prevents browser autofill
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    borderRadius: '12px',
                                    height: '41px',
                                    fontSize: '12.8px',
                                    fontWeight: '400',
                                    padding: "0 16px"
                                },
                                '& .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#ccc' // Change border color
                                },
                                '&:hover .MuiOutlinedInput-notchedOutline': {
                                    border: '2px solid #fec6aa'
                                },
                                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                    borderColor: '#FF7E31' // Border color when focused
                                },
                                '&.Mui-focused-visible': {
                                    border: 'none'
                                }
                            }}
                        />
                    )}
                />
                {errorMessage && isTouched && <ErrorMessage message={errorMessage} />}
            </div>
        </div>
    )
}
